export type AppEnvironment = "dev" | "production";

export interface ResolveAppEnvironmentInput {
  readonly viteEnv: string | undefined;
  readonly fallback: AppEnvironment;
}

export function resolveAppEnvironment(
  input: ResolveAppEnvironmentInput,
): AppEnvironment {
  const raw = input.viteEnv?.trim().toLowerCase();
  if (raw === "dev" || raw === "production") {
    return raw;
  }
  return input.fallback;
}

export function getAppEnvironment(): AppEnvironment {
  return __HOVER_IDLE_APP_ENVIRONMENT__;
}

export function isAdminPanelAvailable(env: AppEnvironment): boolean {
  return env === "dev";
}

export function isBalanceLabAvailable(env: AppEnvironment): boolean {
  return env === "dev";
}

export function isAdminPurgeAvailable(env: AppEnvironment): boolean {
  return env === "dev";
}
